import get from 'lodash/get';
import useToggles from './useToggles';

const useToggleCheck = (toggle) => {
  const toggles = useToggles();
  return get(toggles, toggle, false);
};

export default useToggleCheck;
